module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/5379f958ae1d41c9d153a99a6db3bdc4.png";